import React from "react";
import "../scss/hero-section.scss";
import { getItem } from "../helper/localstorage.helper";
import { useSelector } from "react-redux";
import { HeroSectionDesktop } from "./hero-section-desktop.component";
import { HeroSectionMobile } from "./hero-section-mobile.component";
import { ChristmasOfferBanner } from "./christmas-offer-banner.component";

interface RootState {
  auth: {
    user: string | null;
  };
}

export const HeroSection = () => {
  const userType = getItem('userType') || '';
  const user = useSelector((state: RootState) => state.auth.user);
  const [showChristmasOffer, setShowChristmasOffer] = React.useState(true);

  const handleCloseOffer = React.useCallback(() => {
    setShowChristmasOffer(false);
  }, []);

  return (
    <>
      {showChristmasOffer && (
        <ChristmasOfferBanner onClose={handleCloseOffer} />
      )}
      <div className="d-xl-none">
        <HeroSectionMobile userType={userType} user={user} />
      </div>
      <div className="d-none d-xl-block">
        <HeroSectionDesktop userType={userType} user={user} />
      </div>
    </>
  );
};
